module.exports = __webpack_public_path__ + "img/group.24eb805d.svg";